// Central place for env access + fail-fast validation, mirroring the
// checks the old streamlit_app.py did at startup (API_BASE / API_SECRET_KEY
// must be configured).

const API_BASE = import.meta.env.VITE_API_BASE;
const API_SECRET_KEY = import.meta.env.VITE_API_SECRET_KEY;

if (!API_BASE) {
  throw new Error("VITE_API_BASE environment variable is not configured");
}

if (!API_SECRET_KEY) {
  throw new Error("VITE_API_SECRET_KEY environment variable is not configured");
}

// Strip any trailing slash so callers can safely do `${API_BASE}/path`.
export const config = {
  apiBase: API_BASE.replace(/\/+$/, ""),
  apiSecretKey: API_SECRET_KEY,
};
